import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { BackendApiService } from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import _ from 'lodash';
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-badlamarket',
  templateUrl: './badlamarket.component.html',
  styleUrls: ['./badlamarket.component.scss'],
})
export class BadlamarketComponent implements OnInit, OnDestroy {
  badlaRecord: any = [];
  randomString = this.getRandomString(5);
  badlaRoomString = this.getRandomString(6);
  subscription: Subscription;
  subscriptionBadla: Subscription;
  subscriptionGetRate: Subscription;
  subscriptionAry: Subscription[] = [];
  subscriptionDetail;
  subscriptionInstrument;
  marketType;
  badlaInstruments;
  totalRoom = [];
  uniqId = this.getRandomString(5);
  accessApproval: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private backendSocketService: BackendSocketService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.marketType = params.type;
      let authToken = params.authToken;
      let reqObj = {
        token: authToken,
      };
      this.backendApiService.checkAuthToken(reqObj).subscribe((response) => {
        if (response['status'] == true) {
          this.accessApproval = true;
          localStorage.setItem('accessToken', authToken);
          localStorage.setItem('userId', response['userId']);
        } else {
          this.accessApproval = false;
        }
      });
      if (params.type == 'market') {
        let filterData = {
          userId: 1,
        };
        this.backendApiService
          .badlaInstruments(filterData)
          .subscribe((response) => {
            if (response.status == true) {
              this.badlaRecord = response.data;
              this.badlaRecord.sort((a, b) => a.name.localeCompare(b.name));

              this.setInstrument(this.badlaRecord);
            }
          });
      }
      this.getRate();

      if (params.type == 'livebadla') {
        let data = {
          isActive: true,
        };
        this.backendApiService
          .liveBadlaInstruments(data)
          .subscribe((response) => {
            if (response.status == true) {
              this.badlaInstruments = response.data;
              let badlaData = response.data;
              let instrumentAry = [];
              // _.map(badlaData, function (res) {
              //   instrumentAry = instrumentAry.concat(res.instrumentToken);
              // },this)
              badlaData.forEach((element) => {
                // let badlaInstId = element._id;
                // let instrumentToken = element.instrumentToken;
                instrumentAry = _.map(
                  element.instrumentToken,
                  function (resIns) {
                    return resIns + '_full';
                  },
                );
                element.instrumentToken = instrumentAry;
                this.setBadlaInstrument(element);
              });
              // instrumentAry = _.map(instrumentAry, function (resIns) {
              //   return resIns + "_full";
              // })
              // console.log('instrumentAry++++++++',instrumentAry);
              // this.setBadlaInstrument(instrumentAry);
            }
          });
      }
    });
  }

  sortFields(field) {
    console.log('field', field);
    let sortOrder = $('#' + field).attr('data-sort');
    if (field == 'expiry') {
      if (sortOrder == 'asc') {
        $('#' + field).attr('data-sort', 'des');
        $('#' + field).removeClass('text-left sortable');
        $('#' + field).addClass('text-left sortable desc');
        this.badlaRecord.sort((a, b) => {
          const dateA = new Date(a.expiry.split('-').reverse().join('-'));
          const dateB = new Date(b.expiry.split('-').reverse().join('-'));
          return dateA.getTime() - dateB.getTime();
        });
      } else {
        $('#' + field).attr('data-sort', 'asc');
        $('#' + field).removeClass('text-left sortable desc');
        $('#' + field).addClass('text-left sortable');
        this.badlaRecord.sort((a, b) => {
          const dateA = new Date(a.expiry.split('-').reverse().join('-'));
          const dateB = new Date(b.expiry.split('-').reverse().join('-'));
          return dateB.getTime() - dateA.getTime();
        });
      }
    } else {
      if (sortOrder == 'asc') {
        $('#' + field).attr('data-sort', 'des');
        $('#' + field).removeClass('text-left sortable');
        $('#' + field).addClass('text-left sortable desc');
        this.badlaRecord.sort((a, b) => a[field].localeCompare(b[field]));
      } else {
        $('#' + field).attr('data-sort', 'asc');
        $('#' + field).removeClass('text-left sortable desc');
        $('#' + field).addClass('text-left sortable');
        this.badlaRecord.sort((a, b) => b[field].localeCompare(a[field]));
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionBadla) {
      this.subscriptionBadla.unsubscribe();
    }
    // console.log('this.subscriptionBadla+++++++',this.subscriptionBadla);
    this.subscriptionAry.forEach((subscription) => subscription.unsubscribe());
    // let totalRoom =  localStorage.getItem('totalRoom');
    // if(totalRoom){
    //   let romAry = totalRoom.split(",");
    //   if(romAry){
    //     romAry.map((rm, index) =>{
    //       this.backendSocketService.leaveRoom(rm);
    //     })
    //   }
    // }
    if (this.subscriptionGetRate) {
      this.subscriptionGetRate.unsubscribe();
    }
  }

  setInstrument(instrumentTokens) {
    let tokenIds = instrumentTokens.map((ite, index) => {
      return ite.instrument_token + '_full';
    });
    tokenIds = tokenIds.toString();
    var requested = {
      roomId: this.randomString,
      instrument_token: tokenIds,
      uniqId: this.uniqId,
      marketType: 'market',
      response_type: 'full',
    };
    this.totalRoom.push(requested.roomId);
    var observable = interval(600);
    this.subscription = observable.subscribe((x) => {
      this.backendSocketService.setInstrument(JSON.stringify(requested));
    });
    localStorage.setItem('totalRoom', this.totalRoom.join(', '));
  }
  setBadlaInstrument(element) {
    let tokenIds = element.instrumentToken.toString();
    let uniqId = element._id;
    var requested = {
      roomId: this.getRandomString(5),
      instrument_token: tokenIds,
      marketType: 'badla',
      uniqId: uniqId,
      equation: element.equation,
      response_type: 'full',
    };
    this.totalRoom.push(requested.roomId);
    var observable = interval(600);
    this.subscriptionBadla = observable.subscribe((x) => {
      this.backendSocketService.setInstrument(JSON.stringify(requested));
    });

    this.subscriptionAry.push(this.subscriptionBadla);
    localStorage.setItem('totalRoom', this.totalRoom.join(', '));
  }

  getRate() {
    this.subscriptionGetRate = this.backendSocketService
      .getInstrument()
      .subscribe((response) => {
        response.data.map((result, index) => {
          //buy multiple color
          let preBuyAmt = $('#' + result.instrument_token + '_prevBuy').val();
          if (Number(result['buy_price_0']) > Number(preBuyAmt)) {
            $('#' + result.instrument_token + '_buyprice')
              .removeClass('debit-color')
              .addClass('credit-color');
          }
          if (Number(result['buy_price_0']) < Number(preBuyAmt)) {
            $('#' + result.instrument_token + '_buyprice')
              .removeClass('credit-color')
              .addClass('debit-color');
          }
          $('#' + result.instrument_token + '_prevBuy').val(
            result['buy_price_0'],
          );

          //sell multi color
          let preSellAmt = $('#' + result.instrument_token + '_prevSell').val();
          if (Number(result['sell_price_0']) > Number(preSellAmt)) {
            $('#' + result.instrument_token + '_sellprice')
              .removeClass('debit-color')
              .addClass('credit-color');
          }
          if (Number(result['sell_price_0']) < Number(preSellAmt)) {
            $('#' + result.instrument_token + '_sellprice')
              .removeClass('credit-color')
              .addClass('debit-color');
          }
          $('#' + result.instrument_token + '_prevSell').val(
            result['sell_price_0'],
          );

          //net multi color
          let preNetAmt = $('#' + result.instrument_token + '_prevNet').val();
          if (Number(result['net_change']) > Number(preNetAmt)) {
            $('#' + result.instrument_token + '_net_change')
              .removeClass('debit-color')
              .addClass('credit-color');
          }
          if (Number(result['net_change']) < Number(preNetAmt)) {
            $('#' + result.instrument_token + '_net_change')
              .removeClass('credit-color')
              .addClass('debit-color');
          }
          $('#' + result.instrument_token + '_prevNet').val(
            result['net_change'],
          );

          $('#' + result.instrument_token + '_buyprice').html(
            result.buy_price_0,
          );
          $('#' + result.instrument_token + '_sellprice').html(
            result.sell_price_0,
          );
          $('#' + result.instrument_token + '_net_change').html(
            result.net_change,
          );
          $('#' + result.instrument_token + '_high').html(result.ohlc.high);
          $('#' + result.instrument_token + '_low').html(result.ohlc.low);
        });
      });
  }

  getRandomString(length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
